import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { CanComponentDeactivate } from 'app/core/guards';
import { CountryService, GlobalFunctionsService, PostalCodeService } from 'app/core/services';
import { Company, Country, Order, Person } from 'app/shared/models';

@Component({
  moduleId: module.id,
  selector: 'fo-contact',
  templateUrl: './contact.page.html'
})
export class ContactPage implements OnInit, CanComponentDeactivate {
  countries: Country[];
  seatsAvailable = 0;
  formDeactivationCheck = false;

  order: Order = new Order();

  @ViewChild('contactForm', { static: false }) form: NgForm;

  constructor(
    private countryService: CountryService,
    private globalFunctionsService: GlobalFunctionsService,
    private postalCodeService: PostalCodeService,
    private router: Router
  ) {
    this.globalFunctionsService.showBasket(true);
    this.globalFunctionsService.showTabs(true);
  }

  getCountries(): void {
    this.countryService.getCountries().then(countries => (this.countries = countries));
  }

  toggleSelf(): void {
    this.globalFunctionsService.updateStudentCount(
      (this.order.Students ? this.order.Students.length : 0) + (this.order.FirstStudentIsContact ? 1 : 0)
    );
  }

  toggleStudents(): void {
    if (this.order.MultipleStudents) {
      const student = new Person();
      student.CountryId = 'NL';
      this.order.Students = [student];
      this.globalFunctionsService.updateStudentCount(
        this.order.Students.length + (this.order.FirstStudentIsContact ? 1 : 0)
      );
    } else {
      this.order.Students = [];
      this.globalFunctionsService.updateStudentCount(
        this.order.Students.length + (this.order.FirstStudentIsContact ? 1 : 0)
      );
    }
  }

  addStudent(): void {
    if (this.seatsAvailable - (this.order.Students.length + (this.order.FirstStudentIsContact ? 1 : 0)) > 0) {
      const student = new Person();
      student.CountryId = 'NL';
      this.order.Students.push(student);

      this.globalFunctionsService.updateStudentCount(
        this.order.Students.length + (this.order.FirstStudentIsContact ? 1 : 0)
      );
    }
  }

  removeStudent(student: Person): void {
    this.order.Students = this.order.Students.filter(s => s !== student);
    this.order.MultipleStudents = this.order.Students.length > 0;

    this.globalFunctionsService.updateStudentCount(
      this.order.Students.length + (this.order.FirstStudentIsContact ? 1 : 0)
    );
  }

  saveInfo(isValid: boolean): void {
    if (isValid) {
      this.globalFunctionsService.updateOrder(this.order);
      this.globalFunctionsService.enableTabs(3);

      // Redirect
      // TODO: Animate
      window.scrollTo(0, 0);
      this.router.navigate(['payment'], { queryParamsHandling: 'merge' });
    }
  }

  previousTab(): void {
    // Redirect
    // TODO: Animate
    window.scrollTo(0, 0);
    this.router.navigate(['courses'], { queryParamsHandling: 'merge' });
  }

  ngOnInit(): void {
    this.order = this.globalFunctionsService.getOrder();
    if (!this.order) {
      // Initial Values
      this.order = new Order();
      this.order.OrderType = 'Private';
      this.order.ContactPerson = new Person();
      this.order.ContactPerson.CountryId = 'NL';
      this.order.Company = new Company();
      this.order.Company.CountryId = 'NL';
      this.order.InvoicePerson = new Person();
      this.order.InvoicePerson.CountryId = 'NL';
      this.order.InvoiceCompany = new Company();
      this.order.InvoiceCompany.CountryId = 'NL';
      this.order.Students = [];

      // Update Storage
      this.globalFunctionsService.updateOrder(this.order);
    }

    this.getCountries();

    // Available Seats
    this.seatsAvailable = this.globalFunctionsService.getSelectedCourse().AvailableSeats;
  }

  canDeactivate(): boolean {
    this.formDeactivationCheck = true;
    return this.form.valid && (this.order.FirstStudentIsContact || this.order.MultipleStudents);
  }

  getAddress(): void {
    this.postalCodeService
      .getAddress(this.order.ContactPerson.PostalCode, this.order.ContactPerson.AddressNumber)
      .then(address => {
        this.order.ContactPerson.Address = address.Street;
        this.order.ContactPerson.City = address.City;
      })
      .catch(() => {
        // Ignore Errors.
      });
  }

  getStudentAddress(student: Person): void {
    this.postalCodeService
      .getAddress(student.PostalCode, student.AddressNumber)
      .then(address => {
        student.Address = address.Street;
        student.City = address.City;
      })
      .catch(() => {
        // Ignore Errors.
      });
  }
}
